<ul [class.flowing-list]="!vertical" [class.vertical-list]="vertical">
  <li #adder cdkOverlayOrigin #trigger="cdkOverlayOrigin" [class.single]="single">
    <form [formGroup]="form" (ngSubmit)="put($event)" [class.input-full-width]="fullWidth">
      @if (!single || !selected) {
        <input nbInput type="text" [maxlength]="maxlength" [fieldSize]="size" [fullWidth]="fullWidth" (keydown)="keydown($event)" (focusin)="focus($event, true)" (focusout)="focus($event, false)" [status]="status" [placeholder]="placeholder ? placeholder : ('search?' | translate)" (ngModelChange)="keychange($event)" formControlName="search">
        <button nbButton type="submit" tabIndex="-1" status="primary" (mousedown)="$event.preventDefault(); $event.stopPropagation();" [size]="size" [disabled]="form.invalid || loading.getValue() || ((!results || !results.length) && !saveunknown) || disabled"><nb-icon [icon]="single ? 'checkmark-circle-2-outline' : 'arrow-circle-right-outline'"></nb-icon></button>
      }
      @if (single && selected) {
        <input type="hidden" formControlName="search">
        @if (!listTemplate) {
          <input nbInput type="text" [fieldSize]="size" [fullWidth]="fullWidth" (keydown)="$event.key === 'Delete' || $event.key === 'Backspace' ? delete(selected) : null" [status]="status" [value]="selected[title_key]" [readOnly]="true">
        }
        @if (listTemplate) {
          <div>
            <ng-container [ngTemplateOutlet]="listTemplate" [ngTemplateOutletContext]="{result:selected, index:-1}"></ng-container>
          </div>
        }
        <button nbButton type="button" tabIndex="-1" ghost status="basic" (mousedown)="$event.preventDefault(); $event.stopPropagation();" (click)="delete(selected); " [size]="size" [disabled]="loading.getValue() || disabled"><nb-icon icon="close-outline"></nb-icon></button>
      }
    </form>
  </li>
  @for (sel of selections; track sel; let i = $index) {
    <li [@.disabled]="flag" [@added]="this.vertical ? 'slideTop' : 'slideIn'">
      @if (selectionTemplate) {
        <ng-container [ngTemplateOutlet]="selectionTemplate" [ngTemplateOutletContext]="{result: sel, index: i, remove: removeItem}"></ng-container>
      } @else {
        <span class="quiet-chip" [ngClass]="'size-' + (size ? size : 'medium')">
          {{ sel[title_key] }}
          <button type="button" class="chip-x" (click)="delete(sel)" [disabled]="disabled" [attr.aria-label]="('delete' | translate) + ' ' + sel[title_key]">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </span>
      }
    </li>
  }
</ul>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="target && (focused || adding)" [cdkConnectedOverlayScrollStrategy]="scrollStrategy" (overlayOutsideClick)="focus($event, false)">
  <nb-option-list [size]="size" class="list-adder-results" [style.min-width]="adder.getBoundingClientRect().width + 'px'"
    [style.width]="fullWidthResults ? 'auto' : (adder.getBoundingClientRect().width + 'px')"
    (mousedown)="$event.preventDefault(); $event.stopPropagation();"
    [nbSpinner]="loading.getValue()" [nbSpinnerSize]="'tiny'">
    @for (res of results; track res; let i = $index) {
      <nb-option #element [value]="res" (click)="put($event, res)" [tabIndex]="-1">
        @if (listTemplate) {
          <ng-container [ngTemplateOutlet]="listTemplate" [ngTemplateOutletContext]="{result:res, index:i}"></ng-container>
        }
        @if (!listTemplate) {
          @if (logos) {
            <div>@if (logo(res); as l) {
              <img [src]="l" alt="logo">
            }</div>
          }
          <span>{{ res[title_key] }}</span>
        }
      </nb-option>
    }
    @if (!results.length && !addnew) {
      <nb-option disabled [nbSpinner]="loading.getValue()" [nbSpinnerSize]="'tiny'">
        {{ (curlength >= this.mintyping ? (this.saveunknown ? '' : 'noresults') : ( curlength === 0 ? (autolist ? noresults : 'starttyping') : 'keeptyping') ) | translate }}
      </nb-option>
    }
    @if (!results.length && addnew) {
      <nb-option (click)="addEntry($event)">
        @if (addnew) {
          <a>{{ 'addnew' | translate }}</a>
        }
      </nb-option>
    }
  </nb-option-list>
</ng-template>
